import { useState, useEffect, useRef } from "react";
import { Table } from 'react-bootstrap';
import '../css/Profile.css';
import useScrollPosition from "../common/useScrollPosition";
import useWindowSize from "../common/useWindowSize";
import config from "../etc/config.json";


function C4FDetailedProfile(props) {

    function getKmCell(incline, surface, bonification, index, currentkm, mintactkm) {
        let colorClass = "";
        let colorClass2 = "";
    
        if (incline < -7) {
            colorClass = "td-steep-dh";
        }
        if (incline < -5 && incline >= -7) {
            colorClass = "td-dh";
        }
        if (incline < -2 && incline >= -5) {
            colorClass = "td-light-dh";
        }
        if (incline < 3 && incline >= -2) {
            colorClass = "td-flat";
        }
        if (incline < 6 && incline >= 3) {
            colorClass = "td-light-mtn";
        }
        if (incline < 8 && incline >= 6) {
            colorClass = "td-mtn";
        }
        if (incline >= 8) {
            colorClass = "td-steep-mtn";
        }
    
        if (index === (currentkm - 1)) {
            colorClass2 = "td-current-km";
        }
        else if (index === (mintactkm - 1)) {
            colorClass2 = "td-mintact-km";
        }
        else {
            colorClass2 = "td-normal-km";
        }
    
    
        switch (bonification) {
            case 'MountainCat1':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung1.png"} alt="1" width="18" /> {incline}</td>;
            case 'MountainCat2':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung2.png"} alt="2" width="18" /> {incline}</td>;
            case 'MountainCat3':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung3.png"} alt="3" width="18" /> {incline}</td>;
            case 'MountainCat4':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung4.png"} alt="4" width="18" /> {incline}</td>;
            case 'MountainCatHC':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung5.png"} alt="HC" width="18" /> {incline}</td>;
            case 'IntermediateSprint':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung6.png"} alt="S" width="18" /> {incline}</td>;
            case 'MountainCat1B':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung7.png"} alt="1B" width="21" /> {incline}</td>;
            case 'MountainCat2B':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung8.png"} alt="2B" width="21" /> {incline}</td>;
            case 'MountainCat3B':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung9.png"} alt="3B" width="21" /> {incline}</td>;
            case 'MountainCat4B':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung10.png"} alt="4B" width="21" /> {incline}</td>;
            case 'MountainCatHCB':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung11.png"} alt="HCB" width="21" /> {incline}</td>;
            case 'IntermediateSprintB':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung12.png"} alt="SB" width="21" /> {incline}</td>;
            case 'MountainCatHCC':
                return <td className={colorClass + " " + colorClass2}><img className="mb-1" src={config.DIR_ICONS + "wertung5.png"} alt="HCC" width="21" /> {incline}</td>;
            default: break;
        }
    
        switch (surface) {
            case "VeryLightCobbles":
                return <td className={colorClass + " " + colorClass2}><img src={config.DIR_ICONS + "star1.png"} alt="*" width="18" /> {incline}</td>;
            case "LightCobbles":
                return <td className={colorClass + " " + colorClass2}><img src={config.DIR_ICONS + "star2.png"} alt="**" width="18" /> {incline}</td>;
            case "MediumCobbles":
                return <td className={colorClass + " " + colorClass2}><img src={config.DIR_ICONS + "star3.png"} alt="***" width="18" /> {incline}</td>;
            case "RoughCobbles":
                return <td className={colorClass + " " + colorClass2}><img src={config.DIR_ICONS + "star4.png"} alt="****" width="18" /> {incline}</td>;
            case "VeryRoughCobbles":
                return <td className={colorClass + " " + colorClass2}><img src={config.DIR_ICONS + "star5.png"} alt="*****" width="18" /> {incline}</td>;
            default:
                return <td className={colorClass + " " + colorClass2}> {incline}</td>;
        }
    }
    
    const [currentSector, setCurrentSector] = useState(props.currentSector);    
    const [tablePos, setTablePos] = useState(props.tablePos);
    const [lastSector, setLastSector] = useState(props.lastSector);
    const tableRef = useRef()
    const km1Ref = useRef()
    const lastkmRef = useRef()
    const scrollPosition = useScrollPosition();
    const size = useWindowSize();

    function scrollToKm() {
        var km1 = km1Ref.current.offsetTop
        var km2 = lastkmRef.current.offsetTop
        tableRef.current.scrollTo(0, Math.max(((km2 - km1) / (lastSector)) * currentSector - 70, 0));
    }

    useEffect(() => {
        setCurrentSector(props.currentSector);
        setTimeout(() => scrollToKm(), 0);
    }, []);

    if (props.profile && props.profile.sectors)
        return <div ref={tableRef} className="col-1 border border-secondary col-1 py-0 px-0 mt-0 ml-1 mb-0 mr-2" style={{ maxHeight: Math.max(100, (size.height - (tablePos - Math.min(scrollPosition, tablePos))) - 20), minWidth: 80, overflow: "auto" }}>
            <Table className="table table-light table-striped table-hover" style={{ maxWidth: "60px", fontSize: "0.8em" }}>
                <thead>
                    <tr className="table-secondary">
                        <th className="th-fixed" style={{ padding: "0px" }}>km</th>
                        <th className="th-fixed" style={{ padding: "1px", textAlign: "right" }}>%</th>
                    </tr>
                </thead>
                <tbody>
                    {props.profile.sectors.map((sector, index) => (
                        <tr>
                            {(() => {
                                if (index === currentSector - 1) {
                                    if (index === 0) {
                                        return <td ref={km1Ref} style={{ padding: "1px", backgroundColor: 'rgba(255, 203, 191, 1)' }}>{index + 1}</td>
                                    }
                                    else if (index === lastSector - 1) {
                                        return <td ref={lastkmRef} style={{ padding: "1px", backgroundColor: 'rgba(255, 203, 191, 1)' }}>{index + 1}</td>
                                    }
                                    else {
                                        return <td style={{ padding: "1px", backgroundColor: 'rgba(255, 203, 191, 1)' }}>{index + 1}</td>
                                    }
                                }
                                else if (index === props.minuteTactStart - 1) {
                                    if (index === 0) {
                                        return <td ref={km1Ref} style={{ padding: "1px", backgroundColor: 'rgba(255, 236, 131, 1)' }}>{index + 1}</td>
                                    }
                                    else if (index === lastSector - 1) {
                                        return <td ref={lastkmRef} style={{ padding: "1px", backgroundColor: 'rgba(255, 236, 131, 1)' }}>{index + 1}</td>
                                    }
                                    else {
                                        return <td style={{ padding: "1px", backgroundColor: 'rgba(255, 236, 131, 1)' }}>{index + 1}</td>
                                    }
                                }
                                else {
                                    if (index === 0) {
                                        return <td ref={km1Ref} style={{ padding: "1px" }}>{index + 1}</td>
                                    }
                                    else if (index === lastSector - 1) {
                                        return <td ref={lastkmRef} style={{ padding: "1px" }}>{index + 1}</td>
                                    }
                                    else {
                                        return <td style={{ padding: "1px" }}>{index + 1}</td>
                                    }
                                }
                            })()}
                            {getKmCell(sector.incline, sector.surface, sector.bonification, index, currentSector, props.minuteTactStart)}
                        </tr>
                    ))}
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                    <tr><td style={{ padding: "1px" }}>.</td><td style={{ padding: "1px" }}></td></tr>
                </tbody>
            </Table>
        </div>
    else return null;
}

export default C4FDetailedProfile;
